export class AuditAccessibilityModel {
    constructor() {}
    artifactTypeId:number;
    artifactAccessibilityId:number;
}